const GetInTouchSection = () => {
  const contactItems = [
    {
      id: 1,
      icon: "assets/images/contact/1.png",
      alt: "phone-icon",
      details: ["+0124-2980883, +0124-4383765"],
      animation: "fade-right",
      duration: "1000"
    },
    {
      id: 2,
      icon: "assets/images/contact/2.png",
      alt: "email-icon",
      details: ["asiaticstock@gmail.com"],
      animation: "fade-right",
      duration: "1100"
    },
    {
      id: 3,
      icon: "assets/images/contact/3.png",
      alt: "address-icon",
      details: ["Plot no 38, Road no-A27, DLF Phase-1, Gurugram, Haryana-122002"],
      animation: "fade-right",
      duration: "1200"
    }
  ];

  return (
    <div className="team team--details padding-top padding-bottom bg-color-3 py-5">
      <div className="container">
        <div className="team__wrapper">
          <div className="row g-5 align-items-center">
            {/* Left Column - Contact Information */}
            <div className="col-md-6">
              <div className="section-header mb-3">
                <h2 className="text-uppercase">Get In<span className="style2"> Touch</span></h2>
              </div>
              
              <div className="team__content">
                <div className="contact__details">
                  {contactItems.map((item) => (
                    <div 
                      key={item.id}
                      className="contact__item aos-init aos-animate" 
                      data-aos={item.animation}
                      data-aos-duration={item.duration}
                    >
                      <div className="contact__item-inner">
                        <div className="contact__item-thumb">
                          <span>
                            <img 
                              src={item.icon} 
                              alt={item.alt} 
                              className="dark" 
                            />
                          </span>
                        </div>
                        <div className="contact__item-content">
                          {item.details.map((detail, index) => (
                            <p key={index}>{detail}</p>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Column - Image */}
            <div className="col-md-6">
              <div className="team__thumb">
                <img 
                  src="assets/images/blog/image-1.jpg" 
                  alt="Team Image" 
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouchSection;